import { ArrowBackIcon } from '@chakra-ui/icons';
import { BoxProps } from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { CmBox, CmFlex } from '@/components/uiParts';

export const BackButton: React.FC<BoxProps> = ({
  children,
  ...rest
}): JSX.Element => {
  const history = useHistory();

  //
  const handleClick = () => {
    history.goBack();
  };

  return (
    <CmBox cursor="pointer" onClick={handleClick} {...rest}>
      <CmFlex display="inline-block" align="center" fontSize="md">
        <ArrowBackIcon mr={1} />
        {children}
      </CmFlex>
    </CmBox>
  );
};
